export default __webpack_public_path__ + "static/media/Homepage_image-copy.c444313f.png";